import { useEffect } from "react";
import "../App.css";

import { Dialog, Group, Button, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";


import Swal from 'sweetalert2'

function S4(props) {
  const [opened, { toggle, close }] = useDisclosure(false);
  
  const start = () => {
    setTimeout(() => {
      toggle()
    }, 1000)
  }

  useEffect(() => {
    start()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const onCheck = (option) => {
    if (!option) {
      props.youGay();
      close()
    } else {
      Swal.fire("Good!", "A man doesn't need sweet things", "success")
      props.next()
      close()
    }
  };

  return (
    <>
      <Dialog
        opened={opened}
        withCloseButton={false}
        onClose={close}
        size="lg"
        radius="md"
      >
        <Text size="xl" mb="xs" weight={500}>
          Accept the usage of cookies for a better experience 🍪
        </Text>

        <Group>
          <Button color="teal" onClick={() => onCheck(false)}>Accept cookies</Button>
          <Button color="dark" onClick={() => onCheck(true)}>Don't accept</Button>
        </Group>
      </Dialog>
    </>
  );
}

export default S4;
